<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'uploadimg',
})
</script>
<template>
  <a-upload
      v-model:file-list="fileList"
      :action="action"
      list-type="picture-card"
      :maxCount="1"
      accept=".jpg,.jpeg,.png,.gif,.bmp"
      @change="change"
    >
      <div v-if="fileList.length==0">
        <plus-outlined />
        <div style="margin-top: 8px">上传图片</div>
      </div>
    </a-upload>
</template>
<script setup lang="ts" name="uploadimg">
import { PlusOutlined } from '@ant-design/icons-vue'
import { ref,defineEmits,defineProps,watch,onMounted } from 'vue'
import { baseURL } from '@/utils/util'
import type { UploadProps } from 'ant-design-vue'
  const props=defineProps({
      value:{type:String}
  })
  const first=ref<boolean>(true)
  const action=ref<string>(baseURL+'/Upload/UploadWangEditor')
  const fileList=ref<UploadProps['fileList']>([])
  const emits= defineEmits(['update:value'])
  const change=(f:any)=>{
    fileList.value=f.fileList
    let url:String=''
    f.fileList.forEach(e => {
      if(e.response&&e.response.state==1){
        if(Array.isArray(e.response.data)){
            url=e.response.data[0].href
        }else{
            url=e.response.data.href
        }
      }
    })
    emits('update:value',url)
  }
  onMounted(()=>{
    if(props.value){
      if(typeof(props.value)=="string"){
        var list=[]
        var o:any={
          url:baseURL+props.value,
          thumbUrl:baseURL+props.value,
          status:'done',
          response:{state:1,data:{url:baseURL+props.value,href:props.value}}
        }
        list.push(o)
        fileList.value=list
      }
      }
  })

</script>
